
export const navParentItems = [
  {
    title: 'Dashboard',
    icon: 'la-home',
    page: '/parent',

  },
  // {
  //   title: 'เอกสารนักเรียน',
  //   icon: 'la la-file-text',
  //   page: 'null',
  //   submenu: {
  //     items: [
  //       {
  //         title: 'ใบลานักเรียน',
  //         icon: 'la-arrow-circle-right',
  //         page: '/parent/student/leave',
  //         id: ''
  //       },
  //       {
  //         title: 'ใบขออนุญาตออกนอกโรงเรียน',
  //         icon: 'la-arrow-circle-right',
  //         page: '/student/document/out-school',
  //         id: ''
  //       }
  //     ]
  //   }
  // },
  // { section: 'APPS', icon: 'la-ellipsis-h' },
  // {
  //   title: 'การสแกนบัตร',
  //   icon: 'la la-check-square-o',
  //   page: '/parent/prisoner'
  // },
  // {
  //   title: 'ความประพฤติ',
  //   icon: 'la la-users',
  //   page: '/parent/prisoner'
  // },
  // {
  //   title: 'ผลการเรียน',
  //   icon: 'la la-chart-bar',
  //   page: '/parent/dashboard'
  // },
  // {
  //   title: 'ตารางเรียน',
  //   icon: 'la la-th-list',
  //   page: '/parent/dashboard'
  // },
  // {
  //   title: 'SDQ',
  //   icon: 'la la-list-alt',
  //   page: '/parent/dashboard'
  // }
];